<template>
  <div class="stack-page f-c" v-loading="loadingStackPage">
    <warehouse-info />
    <stack-content
      :stacks="stacks"
      :search-form="searchForm"
      :search-form-change="searchFormChange"
      :stack-slots="stackSlots"
      :slot-table-headers="slotTableHeaders"
      :stack-section-table-headers="stackSectionTableHeaders"
      :section-slot-data="sectionSlotData"
      :section-slot-table-headers="sectionSlotTableHeaders"
    />
  </div>
</template>
<script>
// components
import WarehouseInfo from '@/components/stack/WarehouseInfo.vue'
import StackContent from '@/components/stack/StackContent.vue'
// api
import { queryStackSlots, parseStackNo, filterSlot } from '@/api/stack'
// models
import {
  StackSearchForm,
  StackSearchParamsWrapUp,
  StackSlotTableHeaders,
  StackSectionTableHeaders,
  StackSlotWithPalletTableHeaders
} from '@/core/models/stack'
// others
import cloneDeep from 'lodash/cloneDeep'
import sortBy from 'lodash/sortBy'

export default {
  name: 'StackPage',
  data() {
    return {
      stacks: {},
      stacksInfo: null,
      loadingStackPage: false,
      stackSlots: [],
      slotTableHeaders: StackSlotTableHeaders,
      sectionSlotData: [],
      stackSectionTableHeaders: StackSectionTableHeaders,
      sectionSlotTableHeaders: StackSlotWithPalletTableHeaders
    }
  },
  components: {
    WarehouseInfo,
    StackContent
  },
  methods: {
    async queryStackSlots() {
      const temp = StackSearchParamsWrapUp(this.searchForm)
      if (temp.slotFuzzy.length < 1) return
      const slotFuzzy = temp.slotFuzzy
      temp.slotFuzzy = temp.slotFuzzy.slice(0, 4)

      this.loadingStackPage = true
      const stacks = await queryStackSlots(temp)
      const slots = []
      stacks.forEach(e => slots.push(...e.slots))

      const filters = parseStackNo(slotFuzzy)
      const stackSlots = []
      slots.forEach(slot => {
        const parsed = parseStackNo(slot.no)
        if (filterSlot(parsed, filters)) {
          stackSlots.push({
            ...parsed,
            // palletNo: slot.pallet?.no
            // pallets: slot.pallets
            palletCnt: (slot.pallets ?? []).length
          })
        }
      })
      this.stackSlots = sortBy(stackSlots, [
        'rowNo',
        'stackNo',
        'sectionNo',
        'slotNo'
      ])
      this.stacks = Object.fromEntries(stacks.map(one => [one.no, one]))

      this.loadingStackPage = false
    },
    getSectionSlotData(stack, sectionNo) {
      const slotPerSection = stack.slotPerSection
      const sectionSlotData = []
      for (let i = 0; i < slotPerSection; i++) {
        const temp = {}
        temp.slotNo = String.fromCharCode(97 + i)
        const slotsWithTheSlotNo = stack.slots.filter(slot => {
          const parsed = parseStackNo(slot.no)
          const filters = { slotNo: temp.slotNo, sectionNo: sectionNo }
          return filterSlot(parsed, filters)
        })
        temp.palletNo = slotsWithTheSlotNo[0].palletNo
        sectionSlotData.push(temp)
      }
      this.sectionSlotData = sectionSlotData
    },
    searchFormChange() {
      this.queryStackSlots()
    }
  },
  computed: {
    searchForm() {
      const temp = cloneDeep(StackSearchForm)
      return temp
    }
  },
  mounted() {
    //
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.stack-page {
  height: 100%;

  .stack-content {
    flex-grow: 1;
  }
}
</style>
